import axios from 'axios'

const baseURL = process.env.REACT_APP_API_URL
const apiKey = process.env.REACT_APP_API_KEY
const xApiKey = process.env.REACT_APP_X_API_KEY

export function addNewBookingRequest(data) {
  const parameters = JSON.stringify(data)
  return axios.post(baseURL + 'bookings?TenantId=' + data.tenantId, parameters, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': apiKey,
      'X-Api-Key': xApiKey
    }
  })
}

export function getBookingList(parameters) {
  return axios.get(baseURL + 'bookings?pageSize=' + parameters.pageSize + '&pageNumber=' + parameters.pageNumber + '&FromDate=' + parameters.fromDate + '&ToDate=' + parameters.toDate + '&RegNo=' + parameters.regNo + '&CustomerName=' + parameters.customerName, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': apiKey,
      'X-Api-Key': xApiKey
    }
  })
}

export function deleteBookingRequest(id) {
  return axios.delete(baseURL + 'bookings/' + id, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': apiKey,
      'X-Api-Key': xApiKey
    }
  })
}

export function updateBookingRequest(data) {
  const parameters = JSON.stringify(data)
  return axios.patch(baseURL + 'bookings/' + data.id, parameters, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': apiKey,
      'X-Api-Key': xApiKey
    }
  })
}

export function bookingReminderRequest(id) {
  return axios.post(baseURL + 'bookings/bookingReminders/' + id, null, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': apiKey,
      'X-Api-Key': xApiKey
    }
  })
}

export function getTenantBookingTypes(tenantId) {
  return axios.get(baseURL + 'external/tenantBookingTypes?tenantId=' + tenantId, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': apiKey,
      'X-Api-Key': xApiKey
    }
  })
}
